import moment from "moment";

export const isEmail = (email) => {
  if(!email) {
      return false
  }
  let regex = /^([a-zA-Z0-9_.+-Çç])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  return regex.test(email);
}

export const getDayName = (timestamp) => {
  let day = moment(timestamp?.toJSDate()).calendar(null, {
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: 'dddd D MMM',
    lastDay: '[Yesterday] D MMM',
    lastWeek: 'dddd D MMM',
    sameElse: 'dddd D MMM'
  })
  return day
}

export const getDayNameWithTime = (timestamp) => {
  let day = moment(timestamp?.toJSDate()).calendar(null, {
    sameDay: '[Today] HH:mm',
    nextDay: '[Tomorrow] HH:mm',
    nextWeek: 'D MMM HH:mm',
    lastDay: '[Yesterday] D MMM HH:mm',
    lastWeek: 'D MMM HH:mm',
    sameElse: 'D MMM HH:mm'
  })
  return day
}

export const checkThatIsNumber = (str) => {
  return (str && /^\d+$/.test(str?.trim())) ? true : false;
}

export const capitalizeFirst = (str) => (str && str[0]) ? str[0].toUpperCase() + (str.slice(1) || "") : ""

export const formatListWithLabels = (value, labels = {}, separator = ", ") => {
  if (value == null) return ""
  const arr = Array.isArray(value) ? value : String(value).split(",").map((s) => s.trim()).filter(Boolean)
  return arr.map((v) => labels[v] ?? capitalizeFirst(v)).filter(Boolean).join(separator)
}